import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const location = useLocation();

  console.log('PrivateRoute check:', {
    token: !!token,
    userRole: user.role,
    allowedRoles,
    pathname: location.pathname,
    userDetails: user,
  });

  if (!token) {
    console.warn('No token found, redirecting to /login');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    console.warn(`Role ${user.role} not allowed for ${allowedRoles}, redirecting to /unauthorized`);
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return children;
};

export default PrivateRoute;